import { render, staticRenderFns } from "./PaymentMethodTab.vue?vue&type=template&id=5c3f408e&scoped=true"
import script from "./PaymentMethodTab.vue?vue&type=script&lang=js"
export * from "./PaymentMethodTab.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodTab.vue?vue&type=style&index=0&id=5c3f408e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f408e",
  null
  
)

export default component.exports